import React, { FunctionComponent } from 'react';
import Avatar from 'react-avatar';
import { IUserAvatarProps } from './types';

export const UserAvatar: FunctionComponent<IUserAvatarProps> = ({ userInfo, size, classes, styles }) => {
  const defaultSize = '35';
  return (
    <>
      {userInfo.image ? (
        <img
          src={userInfo.image}
          alt={`${userInfo.firstName} ${userInfo.lastName}`}
          className={`small-avatar ${classes ?? ''}`}
          style={{
            borderRadius: '50%',
            height: `${size ?? defaultSize}px`,
            width: `${size ?? defaultSize}px`,
            ...styles,
          }}
        />
      ) : (
        <Avatar
          className={`darkGray-bg ${classes ?? ''}`}
          title={`${userInfo.firstName} ${userInfo.lastName}`}
          name={`${userInfo.firstName} ${userInfo.lastName}`}
          alt={`${userInfo.firstName} ${userInfo.lastName}`}
          textSizeRatio={2}
          size={size ?? defaultSize}
          round={true}
          style={{ cursor: 'pointer', ...styles }}
        />
      )}
    </>
  );
};
